module.exports = __webpack_public_path__ + "static/media/shopping.8c65a060.svg";